import FacilityData from './data';
import RoomDetails from '../RoomDetails';

const Facilities = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">The Cabin</span>
          <h2>Room to gather, room to rest.</h2>
          <p>
            From the dorm room and four bedrooms to the basement apartment, our log cabin sleeps
            twenty-seven across generous, comfortable spaces — plus everything you need outdoors.
          </p>
        </div>

        <div className="facility-grid">
          {FacilityData.map((facility) => (
            <RoomDetails key={facility.name} room={facility} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Facilities;
